<template>
  <div id="app">
    <div class="container-fluid">
      <MenuRock />
      <br>
      <router-view/>
      <br>
      <FooterRock />
    </div>
  </div>
</template>

<script>
import MenuRock from './components/MenuRock.vue'
import FooterRock from './components/FooterRock.vue'

export default {
  name: 'App',
  components: {
    MenuRock,
    FooterRock
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align:center;
  color: #2c3e50;
}

</style>
